import { useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { useIdleTimeout } from '@/hooks/useIdleTimeout';

export const IdleTimeoutManager = () => {
  const { user } = useAuth();

  const { start, stop } = useIdleTimeout({
    timeout: 60 * 60 * 1000, // 1 hour
    onIdle: () => {
      console.log('User logged out due to inactivity');
    },
    onActive: () => {
      console.log('User became active again');
    },
    startOnMount: false, // We'll control when to start
  });

  useEffect(() => {
    if (user) {
      // Start idle timeout when user is logged in
      start();
    } else {
      // Stop idle timeout when user is logged out
      stop();
    }

    return () => {
      stop();
    };
  }, [user, start, stop]);

  // This component doesn't render anything
  return null;
};

export default IdleTimeoutManager;